export const getConciliationAdjustmentDisplay = (row, fallbackDocumentTotal) => {
  const table = [row?.tabla, row?.tablaPrincipal, row?.origenTabla, row?.libroContableOriginTableId]
    .map(Number).find(value => value === 44 || value === 45)
  const account = Number(row?.cuenta)
  const label = account === 326 ? 'Ajuste Sencillo' : account === 245 ? 'Tipo de Cambio' : 'Ajuste'
  if (!table && account !== 326 && account !== 245) return null
  const total = Math.abs(Number(row?.montoTotal ?? 0))
  // En tablas 44/45 monto contiene el ajuste, no el monto saldado.
  const amount = Number(row?.monto ?? row?.montoRelacionado ?? 0)
  const documentAmount = row?.montoDocumentoTotal ?? fallbackDocumentTotal
  const documentTotal = Number(documentAmount)
  if (!Number.isFinite(total) || !Number.isFinite(amount)) return null
  const adjustment = documentAmount != null && Number.isFinite(documentTotal)
    ? (Math.abs(documentTotal) > total ? 1 : -1) * Math.abs(amount)
    : -amount
  return { label, total, adjustment }
}
